export default {
    data() {
        return {
            head: {
                link: this.prepareCanonicalLinkTag(),
            },
        };
    },
    methods: {
        prepareCanonicalLinkTag() {
            const url = this.$route.path !== '/' ? this.$config.FRONTEND_BASE_URL + this.$route.path : this.$config.FRONTEND_BASE_URL;

            return [
                {
                    hid: 'canonical',
                    type: 'link',
                    rel: 'canonical',
                    href: url,
                },
            ];
        },
    },
};
